/**
 * lx-title-bar —— 顶部页面标题栏
 *
 * 常驻顶部，显示当前页面名（首页 / 联系人 / 设置）。
 * 适配刘海屏安全区（D4：仅移动端竖屏）。
 */

import { LxElement, define } from '@/core/base-element';
import type { TabKey } from '@/types/events';

const TITLES: Record<TabKey, string> = {
  home: '消息',
  contacts: '联系人',
  settings: '设置',
};

export class LxTitleBar extends LxElement {
  static get observedAttributes(): string[] {
    return ['tab'];
  }

  attributeChangedCallback(): void {
    this.update();
  }

  protected styles(): string {
    return `
      :host {
        display: block;
        background: var(--c-surface);
        border-bottom: 1px solid var(--c-border);
      }

      .bar {
        /* 顶部安全区（刘海屏） */
        padding-top: env(safe-area-inset-top, 0px);
        height: var(--layout-title-bar-h);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding-inline: var(--layout-content-pad-x);
      }

      .title {
        font-size: var(--fs-title);
        font-weight: var(--fw-medium);
        color: var(--c-fg);
        letter-spacing: 0.02em;
      }

      /* 左侧的品牌色圆点，作为低调的视觉锚点 */
      .dot {
        position: absolute;
        left: var(--layout-content-pad-x);
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
        height: 8px;
        border-radius: var(--radius-full);
        background: var(--c-accent);
      }
    `;
  }

  protected render(): string {
    const tab = (this.getAttribute('tab') ?? 'home') as TabKey;
    const title = TITLES[tab] ?? TITLES.home;
    return `
      <header class="bar">
        <span class="dot" aria-hidden="true"></span>
        <h1 class="title">${this.esc(title)}</h1>
      </header>
    `;
  }
}

define('lx-title-bar', LxTitleBar);
